module.exports = __webpack_public_path__ + "img/communicationTypes.3fa8104a.svg";